import {
  createSlice,
  createAsyncThunk
} from '@reduxjs/toolkit'

import {
  getShopifySiteSignConfigAll
} from '../services/store'

// 站点列表是 6 个 shopify 商品页共用的基础数据,收在 store 里避免每页各拉一遍
export const getShopifySites = createAsyncThunk<any, void, any>(
  'shopifyProduct/sites',
  async () => {
    const data = await getShopifySiteSignConfigAll()
    return data || []
  }
)

const shopifyProductSlice = createSlice({
  name: 'shopifyProduct',
  initialState: {
    sites: [],
    createDraft: null
  },
  reducers: {
    setCreateDraft(state, action) {
      state.createDraft = action.payload
    },
    clearCreateDraft(state) {
      state.createDraft = null
    }
  },
  extraReducers: {
    [getShopifySites.fulfilled as any]: (state, action) => {
      state.sites = action.payload
    },
    [getShopifySites.rejected as any]: (state) => {
      state.sites = []
    }
  }
})

const {
  actions,
  reducer
} = shopifyProductSlice

export const {
  setCreateDraft,
  clearCreateDraft
} = actions

export default reducer
